import {StoreType} from '../../../types/SharedTypes';

export const allCategoriesSelector = (state: StoreType) => {
  return state.categoryReducer.categoryResponse;
}
export const categoryParamsSelector = (state: StoreType) => {
  return state.categoryReducer.categoryParams;
}